"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RTMPStreaming = void 0;
exports.getResolution = getResolution;
var _react = _interopRequireWildcard(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _Common = require("./Common");
var _ResolutionInput = require("./ResolutionInput");
var _useUISettings = require("../AppData/useUISettings");
var _useUserPreferences3 = require("../hooks/useUserPreferences");
var _utils = require("../../common/utils");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var RTMPStreaming = function RTMPStreaming(_ref) {
  var onBack = _ref.onBack;
  var _useRecordingStreamin = (0, _reactSdk.useRecordingStreaming)(),
    isRTMPRunning = _useRecordingStreamin.isRTMPRunning;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Common.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.ContentHeader, {
      title: "Start Streaming",
      content: "Choose a destination",
      onBack: onBack
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.ContentBody, {
      Icon: _reactIcons.SettingsIcon,
      title: "RTMP",
      children: "Live Stream your call to Twitch, YouTube, Facebook and any app which supports RTMP, all at the same time"
    }), !isRTMPRunning ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StartRTMP, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(EndRTMP, {})]
  });
};
exports.RTMPStreaming = RTMPStreaming;
var StartRTMP = function StartRTMP() {
  var _useUserPreferences = (0, _useUserPreferences3.useUserPreferences)(_useUserPreferences3.UserPreferencesKeys.RTMP_URLS),
    _useUserPreferences2 = _slicedToArray(_useUserPreferences, 2),
    _useUserPreferences2$ = _useUserPreferences2[0],
    rtmpPreference = _useUserPreferences2$ === void 0 ? [] : _useUserPreferences2$,
    setRTMPPreference = _useUserPreferences2[1];
  var _useState = (0, _react.useState)(rtmpPreference.length > 0 ? rtmpPreference : [{
      name: "Stream",
      id: Date.now(),
      rtmpURL: "",
      streamKey: ""
    }]),
    _useState2 = _slicedToArray(_useState, 2),
    rtmpStreams = _useState2[0],
    setRTMPStreams = _useState2[1];
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var recordingUrl = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectAppData)(_constants.APP_DATA.recordingUrl));
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    record = _useState6[0],
    setRecord = _useState6[1];
  var _useState7 = (0, _react.useState)(_constants.RTMP_RECORD_DEFAULT_RESOLUTION),
    _useState8 = _slicedToArray(_useState7, 2),
    resolution = _useState8[0],
    setResolution = _useState8[1];
  var _useSetAppDataByKey = (0, _useUISettings.useSetAppDataByKey)(_constants.APP_DATA.rtmpStarted),
    _useSetAppDataByKey2 = _slicedToArray(_useSetAppDataByKey, 2),
    isRTMPStarted = _useSetAppDataByKey2[0],
    setRTMPStarted = _useSetAppDataByKey2[1];
  var hasRTMPURL = rtmpStreams.some(function (value) {
    return value.rtmpURL && value.streamKey;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      overflowY: "auto"
    },
    as: "form",
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    },
    children: [rtmpStreams.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        px: "$10"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Accordion.Root, {
        type: "single",
        collapsible: true,
        defaultValue: rtmpStreams[0].id,
        children: rtmpStreams.map(function (rtmp, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Accordion.Item, {
            value: rtmp.id,
            css: {
              border: "2px solid $surfaceLight !important",
              r: "$1",
              my: "$4"
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(AccordionHeader, {
              rtmp: rtmp,
              setRTMPStreams: setRTMPStreams
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Accordion.Content, {
              css: {
                px: "$8",
                py: 0
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RTMPForm, _objectSpread(_objectSpread({}, rtmp), {}, {
                setRTMPStreams: setRTMPStreams,
                testId: "".concat(index, "_rtmp")
              }))
            })]
          }, rtmp.id);
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResolutionInput.ResolutionInput, {
      testId: "rtmp_resolution",
      onResolutionChange: setResolution,
      css: {
        flexDirection: "column",
        alignItems: "start",
        px: "$10",
        my: "$8"
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.RecordStream, {
      record: record,
      setRecord: setRecord,
      testId: "rtmp_recording"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
      css: {
        p: "$8 $10",
        "@lg": {
          display: "flex",
          gap: "$4"
        }
      },
      children: [rtmpStreams.length < 3 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
        "data-testid": "add_stream",
        variant: "standard",
        outlined: true,
        icon: true,
        css: {
          my: "$4",
          w: "100%"
        },
        onClick: function onClick() {
          setRTMPStreams(function (streams) {
            return [].concat(_toConsumableArray(streams), [{
              name: "Stream",
              id: Date.now(),
              rtmpURL: "",
              streamKey: ""
            }]);
          });
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.AddCircleIcon, {}), " Add Stream"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
        "data-testid": "start_rtmp",
        variant: "primary",
        icon: true,
        type: "submit",
        css: {
          w: "100%",
          my: "$4"
        },
        disabled: isRTMPStarted || rtmpStreams.length === 0 && !record,
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var hasInvalidData, urls;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  hasInvalidData = rtmpStreams.find(function (value) {
                    return value.rtmpURL && !value.streamKey || value.streamKey && !value.rtmpURL;
                  });
                  if (!(hasInvalidData || rtmpStreams.length > 0 && !hasRTMPURL)) {
                    _context.next = 4;
                    break;
                  }
                  return _context.abrupt("return");
                case 4:
                  setError("");
                  setRTMPStarted(true);
                  urls = hasRTMPURL ? rtmpStreams.map(function (value) {
                    return "".concat(value.rtmpURL, "/").concat(value.streamKey);
                  }) : [];
                  hmsActions.startRTMPOrRecording({
                    rtmpURLs: urls,
                    meetingURL: recordingUrl || (0, _utils.getDefaultMeetingUrl)(),
                    resolution: getResolution(resolution),
                    record: record
                  });
                  setRTMPPreference(rtmpStreams);
                  _context.next = 16;
                  break;
                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  console.error(_context.t0);
                  setError(_context.t0.message);
                  setRTMPStarted(false);
                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11]]);
        })),
        children: [isRTMPStarted ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Loading, {
          size: 24,
          color: "currentColor"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.GoLiveIcon, {}), isRTMPStarted ? "Starting stream..." : "Go Live"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.ErrorText, {
        error: error
      })]
    })]
  });
};
var EndRTMP = function EndRTMP() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    inProgress = _useState10[0],
    setInProgress = _useState10[1];
  var _useState11 = (0, _react.useState)(""),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var _useRecordingStreamin2 = (0, _reactSdk.useRecordingStreaming)(),
    isRTMPRunning = _useRecordingStreamin2.isRTMPRunning;
  (0, _react.useEffect)(function () {
    if (inProgress && !isRTMPRunning) {
      setInProgress(false);
    }
  }, [inProgress, isRTMPRunning]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Box, {
    css: {
      p: "$4 $10"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Common.ErrorText, {
      error: error
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
      "data-testid": "stop_rtmp",
      variant: "danger",
      css: {
        w: "100%",
        r: "$0",
        my: "$8"
      },
      icon: true,
      loading: inProgress,
      disabled: inProgress,
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                setInProgress(true);
                _context2.next = 4;
                return hmsActions.stopRTMPAndRecording();
              case 4:
                _context2.next = 10;
                break;
              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                setError(_context2.t0.message);
                setInProgress(false);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      })),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.EndStreamIcon, {}), "End Stream"]
    })]
  });
};
var ActionIcon = function ActionIcon(_ref4) {
  var Icon = _ref4.icon,
    onClick = _ref4.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
    as: "span",
    css: {
      mx: "$2",
      cursor: "pointer"
    },
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      width: 16,
      height: 16
    })
  });
};
var FormLabel = function FormLabel(_ref5) {
  var id = _ref5.id,
    children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Label, {
    htmlFor: id,
    css: {
      color: "$textHighEmp",
      my: "$4",
      fontSize: "$sm"
    },
    children: children
  });
};
var RTMPForm = function RTMPForm(_ref6) {
  var rtmpURL = _ref6.rtmpURL,
    id = _ref6.id,
    streamKey = _ref6.streamKey,
    setRTMPStreams = _ref6.setRTMPStreams,
    testId = _ref6.testId;
  var formRef = (0, _react.useRef)(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    id: id,
    direction: "column",
    css: {
      mb: "$8"
    },
    ref: formRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(FormLabel, {
      id: "rtmpURL",
      children: ["RTMP URL", /*#__PURE__*/(0, _jsxRuntime.jsx)(Asterik, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, {
      "data-testid": "".concat(testId, "_url"),
      placeholder: "Enter RTMP URL",
      id: "rtmpURL",
      name: "rtmpURL",
      value: rtmpURL,
      onChange: function onChange(e) {
        setRTMPStreams(function (streams) {
          return updateStream({
            streams: streams,
            id: id,
            value: e.target.value,
            key: e.target.name
          });
        });
      },
      required: true
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(FormLabel, {
      id: "streamKey",
      children: ["Stream Key", /*#__PURE__*/(0, _jsxRuntime.jsx)(Asterik, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, {
      placeholder: "Enter Stream Key",
      id: "streamKey",
      name: "streamKey",
      value: streamKey,
      "data-testid": "".concat(testId, "_key"),
      onChange: function onChange(e) {
        setRTMPStreams(function (streams) {
          return updateStream({
            streams: streams,
            id: id,
            value: e.target.value,
            key: e.target.name
          });
        });
      },
      required: true
    })]
  });
};
var Asterik = function Asterik() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
    variant: "sm",
    as: "span",
    css: {
      color: "$error",
      mx: "$2"
    },
    children: "*"
  });
};
var AccordionHeader = function AccordionHeader(_ref7) {
  var rtmp = _ref7.rtmp,
    setRTMPStreams = _ref7.setRTMPStreams;
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    edit = _useState14[0],
    setEdit = _useState14[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Accordion.Header, {
    css: {
      px: "$8"
    },
    children: [edit ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, {
      defaultValue: rtmp.name,
      autoFocus: true,
      onBlur: function onBlur(e) {
        var value = e.currentTarget.value.trim();
        if (value) {
          setRTMPStreams(function (streams) {
            return streams.map(function (stream) {
              if (stream.id === rtmp.id) {
                stream.name = value;
              }
              return stream;
            });
          });
          setEdit(false);
        }
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        flex: "1 1 0"
      },
      children: rtmp.name
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        mx: "$4",
        gap: "$2"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ActionIcon, {
        onClick: function onClick(e) {
          e.stopPropagation();
          setEdit(true);
        },
        icon: _reactIcons.PencilIcon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionIcon, {
        onClick: function onClick() {
          setRTMPStreams(function (streams) {
            return streams.filter(function (stream) {
              return stream.id !== rtmp.id;
            });
          });
        },
        icon: _reactIcons.TrashIcon
      })]
    })]
  });
};
var updateStream = function updateStream(_ref8) {
  var streams = _ref8.streams,
    id = _ref8.id,
    key = _ref8.key,
    value = _ref8.value;
  return streams.map(function (stream) {
    if (stream.id === id) {
      return _objectSpread(_objectSpread({}, stream), {}, _defineProperty({}, key, value));
    }
    return stream;
  });
};
function getResolution(recordingResolution) {
  var resolution = {};
  if (recordingResolution.width) {
    resolution.width = recordingResolution.width;
  }
  if (recordingResolution.height) {
    resolution.height = recordingResolution.height;
  }
  if (Object.keys(resolution).length > 0) {
    return resolution;
  }
}